import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey1, grey5 } from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { PlayableComponentButton } from '../shared/playable-component.style';
import { Draw } from './canvas/draw.style';

export const DrawView = styled.div``;

export const DrawViewTeacher = styled.div`
  flex-grow: 1;
  height: 100%;

  /* Draw canvas overrides */
  ${Draw} {
    height: 100%;
  }
`;

export const DrawViewStudent = styled.div`
  flex-grow: 1;
  height: 100%;
  /* Draw canvas overrides */
  ${Draw} {
    height: 100%;
  }
`;

export const DrawCanvas = styled.div`
  background-color: ${grey1};
  border-radius: ${rem(borderRadius8)};
  border: 1px solid ${grey5};
  margin: auto;
  position: relative;
  overflow: hidden;
  width: 100%;

  ${PlayableComponentButton} {
    border-radius: 0;
  }
`;

export const DrawViewPreview = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;
